import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import install from './install';
import feedback from './feedback';
import questions from './questions';
import jobs from './jobs';
import category from './category';
import location from './location';
import extra from './extra';

export default combineReducers({
  feedback,
  questions,
  install,
  jobs,
  category,
  location,
  form: formReducer,
  routing: routerReducer,
  extra
});
